export const createSORItem = (sorCode, description, quantity) => {
  return {
    sorCode,
    description,
    quantity
  }
}

export const createJobInstructionItem = (
  id,
  appointmentDateTime,
  preferredTime,
  status,
  outcome,
  taskDescription
) => {
  return {
    id,
    appointmentDateTime,
    preferredTime,
    status,
    outcome,
    taskDescription,
  }
}

export const createNoteItem = (date, noteText) => {
  return {
    date,
    noteText
  }
}

export const createFileItem = (name, documentId, date) => {
  return {
    name,
    documentId,
    date
  }
}

export const createCommunicationItem = (
  communicationText,
  date,
  type,
  code
) => {
  return {
    communicationText,
    date,
    type,
    code
  }
}

export const createPhotoItem = (
  pictureId,
  documentBody,
  mimeType,
  pictureText,
  subject,
  date
) => {
  return {
    pictureId,
    documentBody,
    mimeType,
    pictureText,
    subject,
    date
  }
}
